import { useQuery } from '@tanstack/react-query';

import { alertDefinitionsQueryKeys } from '@/domains/alert-definitions';

export const useAlertDefinitionsQuery = () => {
  const { isLoading, data } = useQuery({
    ...alertDefinitionsQueryKeys.list(),
    // @ts-ignore
    retry: false,
    keepPreviousData: true,
  });

  return {
    isLoading,
    data,
  };
};
